import { web } from "../config/System";

export const translationId = {
  "guest.layout": {
    "login.title": `Selamat datang di halaman login ${web.title}!`,
    "login.header": `Login ke Sistem ${web.title}!`,
    "login.description":
      "Masukkan kredensial akun Anda untuk mengakses sistem.",
    "login.reset-password": "Minta/Lupa Password?",
    "login.new-account": "Belum memiliki akun? Daftar/Registrasi disini",
    "register.title": `Selamat datang di halaman registrasi akun ${web.title}!`,
    "register.description": "Portal Resmi Penerimaan Mahasiswa Baru",
    "register.header": "Registrasi Akun",
    "register.header.title": "Perhatian!",
    "register.header.description":
      "*Khusus untuk peserta lulus SNBP dan SNBT _tidak perlu membuat akun_*. Registrasi ini hanya untuk membuat akun sistem. Proses ini bukan pendaftaran mahasiswa baru. Jika Anda sudah memiliki akun, silakan langsung login tanpa perlu registrasi lagi.",
    "register.step-1": "Registrasi Akun",
    "register.step-2": "Biodata",
    "register.label.nama-lengkap": "Nama Lengkap (Tanpa Gelar)",
    "register.label.konfirmasi-password": "Konfirmasi Password",
    "register.send": "Kirim Email Verifikasi",
    "register.submit": "Submit Data Registrasi",
    "register.has-account": "Sudah memiliki akun? Login disini.",
    "register.sent.title": "Terima kasih telah melakukan registrasi!",
    "register.sent.description-1":
      "Kami telah mengirimkan tautan verifikasi ke email",
    "register.sent.description-2":
      "Silakan periksa kotak masuk dan ikuti langkah-langkah untuk memverifikasi akun Anda. Jika tidak menemukan email, cek folder spam atau promosi. Belum menerima email?",
    "register.sent.resend": "Klik di sini untuk mengirim ulang.",
    "register.label.kewarganegaraan": "Kewarganegaraan",
    "register.label.handphone": "No Handphone/What'sapp",
    "register.label.handphone.description":
      "Pastikan menggunakan nomor aktif dan terhubung dengan what'sapp",
    "register.label.alamat": "Alamat",
    "register.success.title": "Registrasi Anda Berhasil",
    "register.success.description":
      "Terima kasih telah menyelesaikan proses registrasi. Data Anda sudah berhasil disimpan, dan kami sangat antusias menyambut Anda sebagai calon mahasiswa baru. Ayo, langkah berikutnya semakin dekat!",
    "button.send-reset-passsowrd-request": "Kirim Permintaan Reset Password",
    "button.resend-reset-passsowrd-request": "Kirim Ulang",
    "link.go-to-login": "Menuju ke halaman Login",
    "help.title": "Mengalami kendala?",
    "help.description": `Jika ada kendala dalam penggunaan SPMB ${web.univAcronym}, dapat menghubungi Helpdesk UPA-TIK ${web.univAcronym} melalui What'sApp berikut:`,
    "notif.email-sent.1":
      "Kami telah mengirimkan permintaan reset password ke alamat email",
    "notif.email-sent.2":
      "Mohon untuk melakukan pengecekan ke alamat email anda.",
    "button.back": "Kembali",
    "forgot-password.title": "Minta / Atur Ulang Password",
    "forgot-password.description":
      "Masukkan alamat email yang terdaftar. Kami akan mengirimkan tautan untuk mengatur ulang kata sandi Anda.",
    "forgot-password.notice.title":
      "Khusus Peserta Lulus Jalur Nasional (SNBP & SNBT)",
    "forgot-password.notice.description":
      "Anda <strong>wajib</strong> melakukan permintaan password untuk login pertama kali. Pastikan menggunakan <strong>email yang terdaftar di SNPMB Pusat</strong>.",
    "forgot-password.label.email": "Email Terdaftar",
    "forgot-password.button.processing": "Memproses...",
    "forgot-password.button.wait": "Tunggu {{count}} detik...",
    "forgot-password.sent.info": "Dikirim ke:",
    "forgot-password.sent.description":
      "Silakan periksa kotak masuk email Anda untuk instruksi pengaturan ulang kata sandi.",
    "forgot-password.button.back-login": "Kembali Login",
    "reset-password.title": "Atur Password Baru",
    "reset-password.description":
      "Buat password baru yang aman untuk akun Anda.",
    "reset-password.label.password": "Password Baru",
    "reset-password.label.confirm-password": "Konfirmasi Password",
    "reset-password.placeholder.password": "Minimal 8 karakter",
    "reset-password.placeholder.confirm-password": "Ketik ulang password",
    "reset-password.strength.label": "Kekuatan Password:",
    "reset-password.strength.weak": "Lemah",
    "reset-password.strength.medium": "Sedang",
    "reset-password.strength.strong": "Kuat",
    "reset-password.button.submit": "Simpan Password",
    "reset-password.success.title": "Password Berhasil Diubah!",
    "reset-password.success.description":
      "Password Anda telah berhasil diatur ulang. Anda akan diarahkan ke halaman login dalam 3 detik...",
    "reset-password.success.button": "Login Sekarang",
    "reset-password.link.back": "Kembali ke Login",
  },
  "siswa.layout": {
    "dashboard.title": "Halo",
    "dashboard.description": `Selamat datang di Sistem ${web.title} ${web.univ}. Sistem ini dirancang untuk memudahkan proses pendaftaran calon mahasiswa baru dan melakukan daftar kembali. Pastikan anda memilih jalur yang sesuai pada jalur yang tersedia.`,
    "dashboard.search": "Cari berdasarkan nama jalur/periode...",
    "dashboard.search.result.label": "Hasil Pencarian",
    "dashboard.search.result.delete": "Hapus Pencarian",
    "dashboard.search.result.notfound": "Jalur pendaftaran tidak ditemukan!",
    "dashboard.periode.text":
      "Silahkan pilih periode pendaftaran yang tersedia di bawah ini",
    "dashboard.periode.tips":
      "Tips: Scroll ke bawah untuk melihat pilihan periode pendaftaran",
    "dashboard.periode.type-kerjasama": "KERJASAMA",
    "dashboard.periode.program.title": "Program Tersedia",
    "dashboard.periode.action.pilih": "Pilih Jalur ini",
    "dashboard.periode.action.lihat": "Lihat Hasil Seleksi",
    "register.title": "Pendaftaran",
    "register.label.nama-lengkap": "Nama Lengkap (Tanpa Gelar)",
    "register.label.nama-lengkap.description":
      "Nama lengkap harus sesuai dengan ijazah terakhir, tanpa gelar!",
    "register.label.tahun-kelulusan": "Tahun Kelulusan",
    "register.label.jenjang": "Jenjang Daftar",
    "register.label.prodi": "Pilihan Program Studi",
    "register.label.birthdate": "Tanggal Lahir",
    "register.button.daftar": "Daftar Sekarang",
    "register.button.batal": "Batal/Tutup",
    "register.confirmation.title":
      "Apakah anda yakin akan melakukan pendaftaran jalur",
    "register.confirmation.button": "Ya, Daftar Sekarang",
    "register.confirmation.check":
      "DENGAN INI SAYA MENYATAKAN DATA YANG SAYA INPUTKAN SUDAH BENAR.",
    "step.title.warning": "Perhatian!",
    "step.description.sebelumnya": "sebelumnya",
    "step.description.warning":
      "belum terpenuhi!, tidak dapat melanjutkan ke step berikutnya.",
    "button.close": "Tutup/Batal",
  },
  alert: {
    "announcement.admission.title": "Pengumuman Pendaftaran",
    "announcement.passed":
      "Selamat {{nama_lengkap}} | {{nomor_pendaftaran}} anda dinyatakan lulus di program studi {{prodi_nama}}",
    "announcement.not-passed":
      "Mohon maaf {{nama_lengkap}} | {{nomor_pendaftaran}} anda dinyatakan tidak lulus di program studi {{prodi_nama}}",
    "announcement.ukt.title": "Pengumuman UKT",
  },
  ukt: {
    "announcement.alert.payment": "Pembayaran UKT",
    "announcement.alert.provision": `Kelalaian dalam melakukan pembayaran hingga batas waktu yang ditentukan akan dianggap mengundurkan diri dari ${web.univAcronym}`,
    "announcement.alert.procedur": `Setelah melakukan pembayaran/konfirmasi, silakan cetak NIM Anda melalui tombol "Download".`,
    "announcement.title": "Besaran Uang Kuliah Tunggal (UKT)",
    "announcement.ipi": "Iuran Pengembangan Institusi (IPI)",
    "announcement.total": "Total Pembayaran",
    "announcement.determination": "Hasil penetapan UKT belum ditetapkan.",
    "button.unpaid.invoice": "Buat Tagihan",
    "button.unpaid.invoice.regenerate": "Buat Tagihan Ulang",
    "button.unpaid.payment.view": "Lihat Tagihan",
    "button.paid.payment.view": "Lihat Pembayaran",
    "payment.text": "Pembayaran",
    "payment.status-1": "Belum dibayar",
    "payment.status-2": "Sudah Bayar",
    "payment.status-3": "Hapus/Expired",
    "payment.status-4": "Sudah Bayar (tunda)",
    "payment.status-5": "Beasiswa",
    "card.title.1": "Buat Tagihan",
    "card.title.2": "Cetak Tagihan",
    "card.title.2.2": "Cetak Bukti Pembayaran",
    "card.title.3": "Cetak NIM",
    "card.description.1":
      "Fitur ini digunakan untuk membuat tagihan pembayaran mahasiswa melalui metode pembayaran yang dipilih. Tagihan berisi informasi detail pembayaran seperti jumlah yang harus dibayar, kode pembayaran, dan informasi lainya.",
    "card.description.2":
      "Fitur ini digunakan untuk mencetak tagihan pembayaran mahasiswa melalui metode pembayaran yang dipilih. Tagihan berisi informasi detail pembayaran seperti jumlah yang harus dibayar, kode pembayaran, dan informasi lainya.",
    "card.description.3":
      "Fitur ini memungkinkan mahasiswa untuk mencetak dokumen berisi Nomor Induk Mahasiswa (NIM). Dokumen ini berguna sebagai identitas resmi mahasiswa dalam sistem akademik. Terdapat tombol 'Download' untuk mengunduh file dalam format PDF.",
  },
  dataPendaftaran: {
    "nomor-pendaftaran": "Nomor Pendaftaran",
  },
  dataSiswa: {
    "nama-lengkap": "Nama Lengkap",
  },
  dataPilihanProdi: {
    prodi: "Program Studi",
    jurusan: "Jurusan",
    fakultas: "Fakultas",
  },
  invoice: {
    title: "Buat Tagihan",
    description:
      "Pilih metode pembayaran yang akan digunakan, kemudian tekan tombol 'Buat Tagihan'",
    "text.biaya": "Biaya UKT",
    "text.biayaIpi": "Biaya IPI",
    "text.biayaTotal": "Total Biaya",
    "text.method": "Pilih Metode Pembayaran",
    "title.unpaid": "Bayar Tagihan UKT",
    "title.paid": "Data Pembayaran",
    "description.unpaid":
      "Selesaikan pembayaran tagihan UKT sebelum batas akhir pembyaran",
    "description.paid": "Pembayaran sudah dilakukan.",
    "instruction.bri.1":
      "Untuk pembayaran briva diharuskan membayar di media pembayaran BRI. atm, mobile banking, internet banking, atau hanya di teller BRI.",
    "instruction.bri.2":
      "Prosedur Pembayaran dengan Layanan BRI Virtual Account (BRIVA) dapat di lihat disini",
    "instruction.bri.3": "disini",
    "instruction.bpd.1":
      "Pembayaran UKT dan Tagihan Resmi lainnya dapat dilakukan melalui seluruh channel Bank BPD Bali seperti BPD Bali Mobile, Internet Banking Business Bank BPD Bali, Teller Bank BPD Bali dan Balipay Bank BPD Bali dengan input 'Kode Pembayaran'.",
    "instruction.bpd.2":
      "Pembayaran UKT dan Tagihan Resmi lainnya menggunakan kartu ATM Bank BPD Bali di Mesin ATM Bank BPD Bali dilakukan dengan input '0935 + Kode Pembayaran'.",
    "instruction.bpd.3":
      "Pembayaran UKT dan Tagihan Resmi lainnya yang dilakukan melalui Bank lain (transfer online) dapat menggunakan Virtual Account Bank BPD Bali '5382 + Kode Pembayaran'.",
    "instruction.bpd.4":
      "Prosedur Pembayaran dengan Layanan BPD Virtual Account dapat dilihat",
    "instruction.bpd.5": "disini",
    "instruction.bni.1":
      "Untuk pembayaran BNI Virtual Account diharuskan membayar di media pembayaran BNI. atm, mobile banking, internet banking, atau hanya di teller BNI.",
    "instruction.bni.2":
      "Prosedur Pembayaran dengan Layanan BNI Virtual Account dapat di lihat disini",
    "instruction.bni.3": "disini",
    "label.nama-tagihan": "Nama Tagihan",
    "label.nominal": "Nominal",
    "label.kode-pembayaran": "Kode Pembayaran",
    "label.berlaku-hingga": "Berlaku Hingga",
    "label.keterangan": "Keterangan",
    "label.status-pembayaran": "Status Pembayaran",
  },
};
